<template>
  <div>
    <span>{{ message.message }}</span>
    <div class="categories">
      <div
        v-for="article in articleOptions"
        :key="`${message.type}-${article.id}`"
        class="item"
        :class="{
          'selected-item':
            message.selectedOption &&
            (article.id === message.selectedOption || article.id === message.selectedOption.id),
        }"
        @click="buildArticleSelectedEvent(article)"
      >
        <span class="item-text">{{ article.title }}</span>
        <span :class="{ invisible: article.checks }" class="link-icon"> <FaAngleRight /> </span>
      </div>
    </div>

    <template v-if="elements.browseArticles">
      <span>{{ $t('chat.sys.msg.article_other_nav.read_other_articles') }}</span>
      <div class="categories">
        <div
          class="item"
          :class="{ 'selected-item': PredefinedOptionType.BROWSE_OTHER_ARTICLES === message.selectedOption }"
          @click="buildBrowserOtherArticlesSelected"
        >
          <span class="icon-left"> <IoInformationCircleOutline /> {{ $t('chat.sys.msg.browse_articles') }} </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { PredefinedOptionType, SystemEvent, SystemOptionType } from '@/common/bot/enum';
import { isArticleOption } from '@/common/bot/lib/option';
import {
  ArticleListNavigationEvent,
  ArticleListWithOtherNavigationMessage,
  ArticleSystemOption,
} from '@/common/bot/types';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import IoInformationCircleOutline from '@/components/icons/IoInformationCircleOutline.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FaAngleRight,
    IoInformationCircleOutline,
  },
})
export default class ArticleListWithOtherNavigation extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: ArticleListWithOtherNavigationMessage;

  readonly PredefinedOptionType = PredefinedOptionType;

  get articleOptions(): ArticleSystemOption[] {
    const options = this.message.options.filter(isArticleOption) as ArticleSystemOption[];
    // We don't show the not issue not listed if the message
    // does not have connect to agent specified.
    if (!this.elements.issueNotListed) return options;
    return [
      ...options,
      {
        id: PredefinedOptionType.ISSUE_NOT_LISTED,
        kind: SystemOptionType.ARTICLE,
        title: this.t('chat.sys.msg.issue_not_listed', 'My issue is not listed here.'),
        checks: 'DIRTY_ELEMENT_TO_PREVENT_ICON_FROM_SHOWING_UP',
      },
    ];
  }

  get elements() {
    return this.message.elements || {};
  }

  emitSelection(selected: ArticleListNavigationEvent['payload']['selected']) {
    const event: ArticleListNavigationEvent = {
      type: SystemEvent.ARTICLE_LIST_NAVIGATION,
      message: this.message,
      payload: {
        selected,
      },
    };

    this.$emit('send:event', event);
  }

  buildArticleSelectedEvent(article: ArticleSystemOption) {
    const selected =
      article.id === PredefinedOptionType.ISSUE_NOT_LISTED ? PredefinedOptionType.ISSUE_NOT_LISTED : { ...article };
    this.emitSelection(selected);
  }

  buildBrowserOtherArticlesSelected() {
    this.emitSelection(PredefinedOptionType.BROWSE_OTHER_ARTICLES);
  }
}
</script>

<style scoped lang="scss">
@import './ActionButtonCommon.scss';
</style>
